/* eslint-disable react/jsx-curly-newline */
import CheckboxCustom from '@components/common/CheckboxCustom/CheckboxCustom';
import CollapsibleContainer from '@components/common/CollapsibleContainer/CollapsibleContainer';
import { FILTER_CATEGORY_GUEST_RATING, FILTER_EVENT_NAMES } from '@constants/filterValues';
import {
  FilterOptionType,
  RatingFilter,
  SrpFilterOptions,
  SrpFilters,
} from '@customTypes/srp-filters';
import React from 'react';

type Props = {
  srpFilters: SrpFilters | undefined;
  setFilters: (category: string, name: string, eventName: string) => void;
  filterOptions: SrpFilterOptions | undefined;
};

function GuestRatingFilter({ srpFilters, setFilters, filterOptions }: Props) {
  return (
    <div>
      {filterOptions && filterOptions.guest_rating && (
        <CollapsibleContainer
          title="Guest Rating"
          // eslint-disable-next-line no-nested-ternary
          height="60px"
          noBorder
        >
          <div className="flex flex-col gap-5 overflow-hidden mt-0.5 d:mt-0">
            {filterOptions.guest_rating
              .filter((item: FilterOptionType) => item.name.toString().toLowerCase() !== 'any')
              .map((item: FilterOptionType) => (
                <React.Fragment key={item.id}>
                  <CheckboxCustom
                    label={item.description}
                    isChecked={
                      srpFilters ? srpFilters.guest_rating[item.name as keyof RatingFilter] : false
                    }
                    setIsChecked={() =>
                      setFilters(
                        FILTER_CATEGORY_GUEST_RATING,
                        `${item.name}`,
                        FILTER_EVENT_NAMES[FILTER_CATEGORY_GUEST_RATING][item.name],
                      )
                    }
                    id={item.name.toString()}
                    isDarkBorder
                    showStarRating
                    starRating={
                      item.description.toLowerCase() !== 'top rated'
                        ? `${item.name.toString().replace(/[<>=]/g, '')}.0`
                        : ''
                    }
                    isRPColor
                  />
                </React.Fragment>
              ))}
          </div>
        </CollapsibleContainer>
      )}
    </div>
  );
}

export default GuestRatingFilter;
